<template>
<div>
    <div class="flex ai-c jc-sb mt-3 mb-2">
        <div class="mr-2">
            <button
                title="Filters"
                type="button"
                :disabled="is_loading_users"
                :class="{ 'primary': show_filters }"
                @click="show_filters = !show_filters">
                <i class="material-icons">filter_list</i>
                <span v-if="show_filters">Hide Filters</span>
                <span v-else>Show Filters</span>
            </button>
        </div>

        <div class="ml-2 mr-2">
            <vue-table-pagination
                ref="users_table_pagination"
                @vuetable-pagination:change-page="onChangePage">
            </vue-table-pagination>
        </div>

        <div class="ml-2">
            <button class="mr-3" type="button" :disabled="is_loading_users" @click="onRefreshUsers">
                <i class="material-icons">refresh</i>
            </button>
        </div>
    </div>

    <form v-show="show_filters" class="flex ai-c mt-3" @submit.prevent="onFilterSubmit">
        <div class="flex-a flex ai-c mr-2 fs-09">
            <div class="mr-2">
                <label>Facility Number</label>
                <input type="text" v-model="filters.facility_number" />
            </div>

            <div class="fs-09 ml-2 mr-2">
                <label>Tenant Name</label>
                <input type="text" v-model="filters.tenant_name" />
            </div>

            <div class="fs-09 ml-2">
                <label>Insur Ledger ID</label>
                <input type="text" v-model="filters.insur_ledger_id" />
            </div>

            <div class="fs-09 ml-2">
                <label>Unit</label>
                <input type="text" v-model="filters.unit" />
            </div>
        </div>

        <div class="ml-2">
            <button type="reset" @click="onResetFilters">Reset</button>
            <button type="submit">Search</button>
        </div>
    </form>

    <div :class="['mt-3', 'table-wrapper', 'table-loads', { loading: is_loading_users }]">
        <div class="table-error" v-show="load_users_error">
            <span>{{ load_users_error }}</span>
            <button class="text mt-2" :disabled="is_loading_users" @click="onRefreshUsers">Retry?</button>
        </div>

        <vue-table ref="users_table"
            api-url="/api/users?tenants=true"
            :append-params="api_params"
            data-path="data.data"
            :per-page="100"
            table-height="475px"
            pagination-path="data.pagination"
            :http-options="http_options"
            :fields="columns"
            no-data-template="<span>No users to show.</span>"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:loading="is_loading_users = true"
            @vuetable:loaded="is_loading_users = false">
            <template slot="name" slot-scope="props">
                <span v-if="props.rowData.first_name && props.rowData.last_name">
                    {{ props.rowData.first_name }} {{ props.rowData.last_name }}
                </span>

                <span v-else-if="props.rowData.first_name">
                    {{ props.rowData.first_name }}
                </span>

                <span v-else>
                    {{ props.rowData.last_name }}
                </span>
            </template>
        </vue-table>
    </div>
</div>
</template>

<script>
import store from "@/store"
import Vue from "vue"

export default {
    data () {
        return {
            columns: [
                { name: "facility_number", title: "Facility Number" },
                { name: "__slot:name", title: "Tenant Name" },
                { name: "insur_ledger_id", title: "Insur Ledger ID" },
                { name: "unit", title: "Unit" },
                { name: "access_code", title: "Access Code" }
            ],
            filters: {
                facility_number: "",
                insur_ledger_id: "",
                tenant_name: "",
                unit: ""
            },
            http_options: {
                baseURL: this.$http.defaults.baseURL,
                headers: {
                    "X-Authorization": store.state.token.token
                },
                transformResponse: [(raw) => {
                    try {
                        let data = JSON.parse(raw)

                        this.load_users_error = (data.error) ? data.data : ""

                        return data
                    } catch (error) {
                        this.load_users_error = "Unknown error loading users."

                        return raw
                    }
                }]
            },
            is_loading_users: false,
            load_users_error: "",
            show_filters: false,
            store: store
        }
    },

    computed: {
        api_params () {
            const params = {}

            for (const key in this.filters) {
                const value = this.filters[key]

                if (value.length > 0) {
                    params[key] = value
                }
            }

            return params
        }
    },

    methods: {
        /**
         * Update the pagination component when data is received.
         *
         * @param object paginationData Pagination data
         *
         * @return null
         */
        onPaginationData (paginationData) {
            this.$refs.users_table_pagination.setPaginationData(paginationData)
        },

        /**
         * Change the pagination page when requested.
         *
         * @param object page Page
         *
         * @return null
         */
        onChangePage (page) {
            this.$refs.users_table.changePage(page)
        },

        /**
         * Refresh the users table.
         *
         * @return null
         */
        onRefreshUsers () {
            this.$refs.users_table.reload()
        },

        onResetFilters () {
            for (const key in this.filters) {
                this.filters[key] = ""
            }

            Vue.nextTick(() => {
                this.$refs.users_table.reload()
            })
        },

        onFilterSubmit () {
            Vue.nextTick(() => {
                this.$refs.users_table.reload()
            })
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-users-page/TenantAccountsTab.vue